import { HorizontalContainer } from '@american-autonomy/ag-ui';

import WithArrow from 'components/WithArrow';
import BodyText from 'components/text/BodyText';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const DataTableDropdownMenuButton: FunctionComponent<Props> = ({
    className = '',
    icon,
    selectedItemText,
    testId = TEST_ID
}) => (
    <HorizontalContainer
        className={`${className} ${styles.dataTableDropdownMenuButton}`}
        testId={testId}>
        <WithArrow className={styles.withArrow}>
            {icon}

            <BodyText className={styles.bodyText} text={selectedItemText} />
        </WithArrow>
    </HorizontalContainer>
);

export default DataTableDropdownMenuButton;
